import MessagingComponent from './messagingComponent';
import { MESSAGE_TYPE, STATUS_MESSAGE, NO_DATA_MESSAGE, ERROR_MESSAGE } from './constants';

export { MESSAGE_TYPE, STATUS_MESSAGE, ERROR_MESSAGE, NO_DATA_MESSAGE };
export default MessagingComponent;
